/**
 * Whether the user has typed the field name exactly (ignoring surrounding
 * whitespace), gating the destructive delete the way S3 gates bucket deletion.
 * Case-sensitive — field names are lowercase by construction.
 */
export function isDeleteConfirmed(typed: string, fieldName: string): boolean {
  return typed.trim() === fieldName;
}
